import 'katex/dist/katex.min.css';

import { IconButton, Typography, useTheme } from '@mui/material';
import { oneDark as dark, oneLight as light } from 'react-syntax-highlighter/dist/esm/styles/prism';
import Box from "@mui/material/Box";
import CopyIcon from '@mui/icons-material/ContentCopy';
import React from "react";
import ReactMarkdown from "react-markdown";
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import rehypeKatex from 'rehype-katex';
import rehypeRaw from 'rehype-raw';
import remarkEmoji from 'remark-emoji';
import remarkGfm from 'remark-gfm';
import remarkMath from 'remark-math'

const CodeBlock = ({ language, value, style }) => {
    const handleCopy = () => {
        navigator.clipboard.writeText(value).then(() => {
            console.log('Copying to clipboard was successful!');
        }).catch((error) => {
            console.error('Could not copy text: ', error);
        });
    };

    return (
        <div style={{ position: 'relative' }}>
            <SyntaxHighlighter language={language} style={style}>
                {value}
            </SyntaxHighlighter>
            <IconButton onClick={handleCopy}
                sx={{
                    position: 'absolute',
                    top: 2,
                    right: 2,
                }}
            >
                <CopyIcon />
            </IconButton>
        </div>
    );
};

function getRender(type, content, theme) {
    const isDark = theme.palette.mode === 'dark';

    switch (type) {
        case 'you':
            return (
                <Box>
                    <ReactMarkdown
                        rehypePlugins={[rehypeRaw, rehypeKatex]}
                        remarkPlugins={[
                            remarkGfm,
                            remarkMath,
                            remarkEmoji
                        ]}
                    >
                        {content}
                    </ReactMarkdown>
                </Box>
            );
        case 'text':
            if (typeof content !== 'string') {
                return <Typography>Invalid content type for text</Typography>
            }
            return (
                <Box>
                    <ReactMarkdown
                        rehypePlugins={[rehypeRaw, rehypeKatex]}
                        remarkPlugins={[remarkMath, remarkEmoji, remarkGfm]}
                        components={{
                            code({ node, inline, className, children, ...props }) {
                                const match = /language-(\w+)/.exec(className || '');
                                return !inline && match ? (
                                    <CodeBlock
                                        style={isDark ? dark : light}
                                        language={match[1]}
                                        value={String(children).replace(/\n$/, '')}
                                        {...props}
                                    />
                                ) : (
                                    <code className={className} {...props}>
                                        {children}
                                    </code>
                                );
                            },
                            img({ node, ...props }) {
                                return (
                                    <img
                                        alt='img'
                                        style={{
                                            width: '100%',
                                            objectfit: 'contain',
                                            borderRadius: '8px'
                                        }}
                                        {...props}
                                    />
                                );
                            }
                        }}
                    >
                        {content}
                    </ReactMarkdown>
                </Box>
            );
        case 'in_progress':
            return '...';
        default:
            return <div>Invalid Renderer</div>
    }
}

export default function MessageContent({ content, type, ...props }) {
    const theme = useTheme();
    return <Box {...props}>{getRender(type || 'text', content, theme)}</Box>
}
